module.exports = __webpack_public_path__ + "static/media/colegio2.414eb104.png";